import { QueryClient } from "@tanstack/react-query";

type UnauthorizedHandler = () => void;

// Centralized handler invoked when an *authenticated* request returns 401
// (JWT expired/invalid). Wired in app.tsx to clear the auth session and
// redirect to /auth. Its body is not defined here to avoid a circular import
// with the router/store.
//
// The 401 decision lives in apiClient (which knows whether a token was sent),
// NOT in the query/mutation caches: a cache-level 401 handler also fired for
// guest requests to auth-only endpoints (e.g. POST /bookings with no session),
// wrongly logging the user out and bouncing them to /auth. apiClient is the
// single source of truth — it only notifies when a Bearer token was attached.
let onUnauthorized: UnauthorizedHandler | null = null;

export const setOnUnauthorized = (handler: UnauthorizedHandler): void => {
  onUnauthorized = handler;
};

export const notifyUnauthorized = (): void => {
  if (onUnauthorized) onUnauthorized();
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
